import { useQuery } from '@tanstack/react-query';
import { systemApi } from './api';

export const systemKeys = {
  all: ['system'] as const,
  meta: () => [...systemKeys.all, 'meta'] as const,
};

export function useApiMeta() {
  return useQuery({
    queryKey: systemKeys.meta(),
    queryFn: ({ signal }) => systemApi.meta(signal),
    staleTime: 30_000,
  });
}
